import { render, staticRenderFns } from "./Subs.vue?vue&type=template&id=0b45f2d8&scoped=true&"
import script from "./Subs.vue?vue&type=script&lang=js&"
export * from "./Subs.vue?vue&type=script&lang=js&"
import style0 from "./Subs.vue?vue&type=style&index=0&id=0b45f2d8&prod&lang=css&"
import style1 from "./Subs.vue?vue&type=style&index=1&id=0b45f2d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45f2d8",
  null
  
)

export default component.exports